"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const utils_1 = require("../../utils");
const { reducer, initialState } = (0, utils_1.createApiReducer)({
    facets: [],
});
exports.initialState = initialState;
exports.default = reducer;
